import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';

export const makeActionList = (params: any) => {
	const { hasPermission, appName } = params;

	return {
		bulkActions: [],
		rowActions: [],
		addAction: {
			name: 'Edit',
			id: 'edit',
			isEnabled: () => {
				return hasPermission({
					entity: DASHBOARD_RESOURCES.homepageView,
					action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.homepageView].showView,
					appName,
					configPageName: PAGE_NAMES.dashboard
				});
			}
		}
	};
};

export default {
	makeActionList
};
